<template lang="html">
  <el-row>
    <el-col :span="22" :offset="1">
      <el-row class="bg-eee pd-tb10 border-radio10">
        <el-col :span="22" :offset="1">
          <el-row class="pd-tb10">
            <el-input  placeholder="试题描述"></el-input>
          </el-row>
          <el-row class="pd-tb10 center">
            <el-col :span="1" class="center">
              <el-checkbox>A</el-checkbox>
            </el-col>
            <el-col :span="22" :offset="1">
              <el-input  placeholder="请输入内容"></el-input>
            </el-col>
          </el-row>
          <el-row class="pd-tb10 center">
            <el-col :span="1" class="center">
              <el-checkbox>B</el-checkbox>
            </el-col>
            <el-col :span="22" :offset="1">
              <el-input  placeholder="请输入内容"></el-input>
            </el-col>
          </el-row>
          <el-row class="pd-tb10 center">
            <el-col :span="1" class="center">
              <el-checkbox>C</el-checkbox>
            </el-col>
            <el-col :span="22" :offset="1">
              <el-input  placeholder="请输入内容"></el-input>
            </el-col>
          </el-row>
          <el-row class="pd-tb10 center">
            <el-col :span="1" class="center">
              <el-checkbox>D</el-checkbox>
            </el-col>
            <el-col :span="22" :offset="1">
              <el-input  placeholder="请输入内容"></el-input>
            </el-col>
          </el-row>
          <el-row class="fs12 color-theam1">
            <el-col :span="3" :offset="2" class="mouseHand">
              增加选项
            </el-col>
            <el-col :span="3" class="mouseHand" :offset="2">
              删除选项
            </el-col>
          </el-row>
          <el-row class="fs12">
            解析:
          </el-row>
          <el-row class="pd-tb10">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="">
            </el-input>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'HdupMult'
}
</script>
<style lang="scss" scoped>
.center{
  display: flex;
  align-items: center;
}
.bg-eee{
      background: #eee;
}
.border-radio10 {
    border-radius: 10px;
}
</style>
